import { memo } from 'react';
import classNames from 'classnames';
import { isNil } from 'lodash';
import { useTranslation } from 'react-i18next';
// Import Types
import { TitleKeyProps } from 'types';
// Import Components
import Block from './Block';

interface Props extends TitleKeyProps {
    blocks: AnyObject[];
    blocksTypes: string;
    defaultBlockIcon: string;
    cssClassName?: string;
    isReadOnly?: boolean;
}

const BlockGroup: React.FC<Props> = (props) => {
    const { titleKey, blocks, blocksTypes, cssClassName, defaultBlockIcon, isReadOnly = false } = props;
    const { t } = useTranslation();

    return (
        <div
            className={classNames('crm-flow-sidebar-block-group', cssClassName, {
                'crm-flow-sidebar-block-group-read-only': isReadOnly,
            })}
        >
            <div className="crm-flow-sidebar-block-group-head">
                <span>{t(titleKey)}</span>
            </div>

            {!isReadOnly && (
                <div className="crm-flow-sidebar-block-group-body">
                    {blocks.map((block, index) => {
                        const { Name, CustomAttributes } = block;
                        const iconType = !isNil(CustomAttributes?.BCIcon) ? CustomAttributes?.BCIcon : defaultBlockIcon;

                        return (
                            <Block
                                key={index}
                                titleKey={Name}
                                type={blocksTypes}
                                defaultIcon={iconType}
                                cssClassName={cssClassName}
                                metaData={block}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default memo(BlockGroup);
